import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// De lijst-payload is bewust licht (zware velden gestript om de 520/OOM te voorkomen).
// De detail-dialogen halen hun volledige analyse hiermee lazy op bij openen.
export function useAnalysisDetail(listingId, enabled) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const cache = useRef({});

  useEffect(() => {
    if (!enabled || !listingId) return undefined;
    if (cache.current[listingId]) {
      setDetail(cache.current[listingId]);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setDetail(null);
    api
      .get(`/listings/${listingId}/analysis`)
      .then(({ data }) => {
        if (cancelled) return;
        cache.current[listingId] = data;
        setDetail(data);
      })
      .catch(() => {
        if (!cancelled) setDetail(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [listingId, enabled]);

  // Na een mutatie (comparable uitsluiten, handmatige waarde) de verse analyse cachen.
  const patch = (data) => {
    if (!data || !data.listing_id) return;
    cache.current[data.listing_id] = data;
    setDetail(data);
  };

  return { detail, loading, patch };
}
